import React, { useState, useEffect, useRef } from "react";
import { Button, Form, Row, Col, Container } from "react-bootstrap";
import ClientUsers from "./ClientUsers";
import InvoiceRecipients from "./InvoiceRecipients";
import CustomTooltip from "utils/CustomTooltip";

export default function Basic(props) {
  let defaultLogo = require("images/icons/company-logo.png");

  const [fileName, setFileName] = useState("No File Chosen");
  const inputRef = useRef();
  const [imageURL, setImageURL] = useState(props.logo ? props.logo : `/datapulse${defaultLogo}`);
  let companyLogo = <img style={{ maxWidth: "101px", maxHeight: "101px", width: "auto", height: "auto" }} src={imageURL} />;
  return (
    <Container fluid className="p-0 pt-3 px-4 trim-padding">
      <Row className="d-flex mx-0 pt-4 pl-4 pr-4 pb-0 trim-padding flex-column flex-lg-row">
        <Col className="pl-lg-4 px-3 mb-2 flex-grow-3 pb-2 basic-info-container" style={{ backgroundColor: "#EEEEEE" }}>
          <h3 className="mb-2 pt-4 pb-2 section-header">Basic Info</h3>
          <Form.Group>
            <Row>
              <Col>
                <div className="pl-2 pb-2">
                  <span className="f12 visby-medium light-primary ">Company display name</span>
                  <CustomTooltip
                    faClass="far f16 light-primary fa-question-circle pl-2"
                    message="This is how your company name will be displayed in DataPulse. This should be your company name as you would like any client or customer to see it (no entities like LLC, corp., inc., etc. are necessary)."
                    inline={true}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  size="sm"
                  name="company_name"
                  maxLength="30"
                  defaultValue={props.client_company.company_name}
                  className="tableSearch mr-2 mb-2"
                  placeholder=""
                />
              </Col>
            </Row>
          </Form.Group>
          <Row>
            <Col lg={7} xs={12}>
              <div className="pl-2 pb-2">
                <span className="f12 visby-medium light-primary ">Type of client</span>{" "}
              </div>

              <Form.Control className="client-drop mb-3" size="sm" as="select" name="account_type" defaultValue={props.client_account.account_type} lg={7} xs={12}>
                <option disabled hidden>
                  Account Type
                </option>
                <option value="ecommerce">E-Commerce</option>
                <option value="leadgen">Lead Gen</option>
              </Form.Control>
            </Col>
          </Row>
        </Col>
        <Col style={{ backgroundColor: "#EEEEEE" }} className=" mb-2 pb-2 trim-m legal-information-container">
          <div className="pb-1 pl-2">
            <h3 className="mb-2 pt-4 pb-2 pl-2 section-header">Legal Information</h3>
          </div>
          <div className="px-2 pb-3">
            <Row>
              <Form.Label className="ml-3 mr-3 pb-1" style={{ whiteSpace: "nowrap" }}>
                <div className="pl-2 pb-2">
                  <span className="f12 visby-medium light-primary ">
                    Legal company name
                    <CustomTooltip
                      faClass="far f16 light-primary fa-question-circle pl-2"
                      message="This is how your company is named legally. It should be your full company name as it would be listed on a legal document, including your incorporation."
                      inline={true}
                    />
                  </span>
                </div>
              </Form.Label>
            </Row>
            <Form.Group>
              <Form.Control
                size="sm"
                name="legal_company_name"
                defaultValue={props.client_company.legal_company_name}
                className="pb-2 tableSearch mr-2 mb-2 col-11"
                placeholder=""
              />
            </Form.Group>
            <Form.Group>
              <div className="pl-2 pb-2">
                <span className="f12 visby-medium light-primary ">Legal address</span>
              </div>

              <Form.Group>
                <Form.Control
                  size="sm"
                  name="street_address"
                  defaultValue={props.client_company.street_address}
                  className="tableSearch mr-2 mb-2 col-11"
                  placeholder="Street address"
                />
              </Form.Group>
            </Form.Group>
            <Form.Group>
              <Form.Control
                size="sm"
                className="tableSearch mr-2 mb-2 col-11"
                name="unit_building_number"
                defaultValue={props.client_company.unit_building_number}
                placeholder="Unit or building #"
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                size="sm"
                name="city"
                defaultValue={props.client_company.city}
                className="tableSearch mr-2 mb-2 col-11"
                placeholder="City"
              />
            </Form.Group>

            <Row className="justify-content-center">
              <Col className="" xs={12} xl={5}>
                <Form.Control
                  size="sm"
                  name="state_province"
                  placeholder= "State or Province"
                  defaultValue={props.client_company.state_province ? props.client_company.state_province : ""}
                  className="tableSearch mb-2   ">
                </Form.Control>
              </Col>
              <Col className="" xs={12} xl={4}>
                <Form.Control size="sm" name="postal_code" defaultValue={props.client_company.postal_code} className="tableSearch mb-2  " placeholder="Zip" />
              </Col>
              <Col className="" xs={12} xl={3}>
                <Form.Control size="sm" name="country" defaultValue={props.client_company.country} className="tableSearch mb-2 " placeholder="Country" />
              </Col>
            </Row>
          </div>
        </Col>
        <Col style={{ backgroundColor: "#EEEEEE" }} className=" d-flex flex-column align-items-center mb-2 pb-2 trim-m-b company-logo-container">
          <div>
            <h3 className="pt-4 pb-4 section-header text-center">Company Logo</h3>
          </div>
          <div className="pb-3">{companyLogo}</div>
          <div className="pb-3">
            <input
              style={{ backgroundColor: "#3291C1", display: "none" }}
              name="logo"
              className="py-1 m-2"
              type="file"
              ref={inputRef}
              onChange={(e) => {
                if (e.target.files[0].size > 10000000) {
                  alert("Image must be less than 10MB. Consider use another image or compress this one.");
                }
                setImageURL(URL.createObjectURL(e.target.files[0]));
                setFileName(e.target.files[0].name);
              }}
            />

            <Button style={{ backgroundColor: "#3291C1" }} className="py-1 m-2" onClick={() => inputRef.current.click()}>
              Choose File
            </Button>
          </div>
          <div className="pb-2">
            <h5 className="visby-medium">{fileName}</h5>
          </div>
          <div className="px-5 mb-3">
            <p style={{ color: "#7B7DA4 " }} className="f10 nunito-regular text-center">
              Minimum: 600x600px <br />
              Recommended format: .png
              <br />
              Recommended orientation: Landscape
            </p>
          </div>
        </Col>
      </Row>
      <div style={{ backgroundColor: "#EEEEEE" }} className="ml-4 mr-4 mt-2 mb-5 pb-5 trim-margin">
        <ClientUsers {...props} />
        <InvoiceRecipients {...props} />
      </div>
    </Container>
  );
}
